import { useParams } from "react-router-dom";
import CitizenshipContent from "../content/CitizenshipContent";

export default function Citizenship() {
    const { slug } = useParams();

    return <CitizenshipContent currentPage={slug || "home"} />;
}